// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"a31331dc","248":"c07e6903","380":"4c4808ff","472":"400d23ed","509":"15506a65","536":"0e9bedb6","592":"864494f2","804":"7a83f9f9","968":"c9cd0a20"}[chunkId] + ".chunk.js";
};